module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter_title"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "pg17lev1"
    }
  }), _vm._v("PRESERVED KUMQUATS "), _c('span', {
    staticClass: "font2"
  }, [_vm._v("WITH LIME AND CHILE")])]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("Preserved lemons are common in Middle Eastern cuisine, but I’ve played with preserving various kinds of citrus. I tried limes, but they always come out super bitter. Bergamot and Seville oranges are better for marmalades. I really like kumquats here: They’re tart, but the peel is sweet, and the whole fruit—pith, peel, and all—is edible. Lime juice boosts the acidity, and grating in the zest of the limes adds another layer of citrus flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_c('a', {
    attrs: {
      "id": "pg17note1"
    }
  }), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("NOTE:")]), _vm._v(" Oregano Indio is available online from Rancho Gordo.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0016-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("MAKES 1 PT (230 G)")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublistt"
  }, [_c('em', [_vm._v("14 to 18 kumquats (enough to fit in a 1 pt [480 ml] jar), rinsed")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_vm._v("1 or 2 dried arbol chiles, stemmed and seeded")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" cup [75 g] fine sea salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_vm._v("1 tsp dried Mexican oregano, preferably Oregano Indio")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" cup [120 ml] fresh lime juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("8")]), _vm._v(" tsp grated lime zest")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Put a 1 pt [480 ml] canning jar and lid in a large pot and cover with water. Bring to a boil over high heat. Carefully remove the jar and lid with tongs and let dry on a clean towel or rack.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt1"
  }, [_vm._v("Toast the arbol chiles in a small, dry skillet over medium heat to release the oils, shaking the pan occasionally to prevent the chiles from burning, about 1 minute. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt1"
  }, [_vm._v("Cut each kumquat in half from top to bottom, stopping about "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" in [12 mm] from the base, so that it is still intact. Mix the salt with the oregano. Tear the toasted chiles into the salt mixture (you can leave the pieces fairly large). With clean hands, put about "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" tsp of the salt mixture into a kumquat and squeeze over the prepared jar to release the juices while retaining the salt mixture. Put the kumquat in the jar. Repeat with the remaining kumquats.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt1"
  }, [_vm._v("Pour any remaining salt mixture over the kumquats in the jar. Add the lime juice and zest; the kumquats should be submerged. Cover with the lid and seal. Gently shake to help the salt dissolve.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt1"
  }, [_vm._v("Leave the jar in a cool spot in the kitchen for 10 days, gently shaking the jar every day or so. Rinse the kumquats before using or use straight from the jar. They will keep, covered, in the refrigerator for up to 2 months.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16074bb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09chapter02.vue
// module id = 84
// module chunks = 0